import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { apiClaimCheckoutBridge } from '../utils/api';

function getTokenFromUrl() {
  return new URLSearchParams(window.location.search).get('t') || '';
}

// Landing page for the in-app-browser checkout bridge link
// (/checkout?t=...) — see components/InAppBrowserWarning.jsx for where the
// link is minted and routes/checkoutClaim.js's /bridge-claim for the
// server side. No login form, no Vault: this exists purely to redeem the
// one-time token into a real Stripe Checkout Session and redirect there,
// so a visitor who left Facebook/Instagram's in-app browser to pay never
// has to re-authenticate by hand.
export default function CheckoutBridgePage({ onDone }) {
  const { t } = useTranslation('common');
  const [token] = useState(getTokenFromUrl);
  const [error, setError] = useState('');

  useEffect(() => {
    // Strip ?t=... from the address bar (and the one history entry that
    // briefly held it) before doing anything else — it's a spent single-use
    // credential the instant this page reads it, so it shouldn't linger in
    // history or get sent as a referrer to Stripe a moment later.
    window.history.replaceState(null, '', '/checkout');

    if (!token) { setError('invalid'); return; }
    apiClaimCheckoutBridge(token)
      .then(data => {
        // L'email arriva nella risposta, non nell'indirizzo (vedi
        // routes/checkoutClaim.js). Si mette da parte per la schermata di
        // pagamento riuscito, che qui e' un browser dove non si e' mai
        // fatto l'accesso: senza, chi ha appena pagato dovrebbe ridigitare
        // l'indirizzo che ha creato un minuto prima. sessionStorage e non
        // localStorage: vive quanto questa scheda, sopravvive al giro su
        // Stripe e sparisce da sola.
        try { if (data.email) sessionStorage.setItem('ltc_email_ponte', data.email); } catch {}
        window.location.href = data.url;
      })
      .catch(err => setError(err.message || 'invalid'));
  }, []); // eslint-disable-line

  return (
    <div className="auth-page">
      <div className="cloud-layer" aria-hidden="true"><div className="cloud c1"/><div className="cloud c2"/><div className="cloud c4"/><div className="cloud c6"/><div className="cloud c9"/></div>
      <div className="auth-card">
        {!error && (
          <div className="auth-logo">
            <span className="logo-icon">💳</span>
            <h1>{t('checkout_bridge_loading')}</h1>
          </div>
        )}

        {error && (
          <>
            <div className="auth-logo">
              <span className="logo-icon">⚠️</span>
              <h1>{t('checkout_bridge_error_title')}</h1>
            </div>
            <div className="auth-error">
              ⚠ {error === 'expired' ? t('checkout_bridge_error_expired') : t('checkout_bridge_error_generic')}
            </div>
            <button className="btn-primary" onClick={onDone}>{t('checkout_bridge_back_home')}</button>
          </>
        )}
      </div>
    </div>
  );
}
